import React from 'react';
import { observer } from 'mobx-react';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';
import AddDeviceComponent from './Add-device.component';
import useAddDevice from './useAddDevice';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { state, devices, groups, lang, download, handlers, refs, values } =
        useAddDevice(onClose);

    return (
        <>
            <AddDeviceComponent
                lang={lang.lang}
                loading={
                    devices.addDeviceLoading ||
                    groups.loading ||
                    devices.loading
                }
                deviceName={state.deviceName}
                deviceNameError={state.deviceNameError}
                imei={state.imei}
                imeiError={state.imeiError}
                password={state.password}
                passwordError={state.passwordError}
                groupName={state.groupName}
                deviceIconNum={state.deviceIconNum}
                iconSelectVisible={state.iconSelectVisible}
                iconSelectEl={state.iconSelectEl}
                groups={groups.groupsList}
                type={state.type}
                types={values.types}
                additionalInfo={state.additionalInfo}
                keys={state.keys}
                serverError={devices.serverError}
                imeiNotExistError={devices.imeiNotExistError}
                deviceAlreadyExistError={devices.deviceAlreadyExistError}
                deviceAlreadyInUseError={devices.deviceAlreadyInUseError}
                noRightsError={devices.noRightsError}
                iconSelectRef={refs.iconSelectEl}
                uploadError={download.uploadError}
                wrongPasswordError={devices.wrongPasswordError}
                onDeviceNameChange={handlers.handleDeviceNameChange}
                onImeiChange={handlers.handleImeiChange}
                onPasswordChange={handlers.handlePasswordChange}
                onGroupNameChange={handlers.handleGroupNameChange}
                onTypeChange={handlers.handleTypeChange}
                onAdditionalInfoChange={handlers.handleAdditionalInfoChange}
                onAdditionalInfoDateChange={
                    handlers.handleAdditionalInfoDateChange
                }
                onAddClick={handlers.handleAddClick}
                onInputClick={handlers.handleInputClick}
                onSelectIconBtnClick={handlers.handleSelectIconBtnClick}
                onSelectIconWindowClose={handlers.handleSelectIconWindowClose}
                onIconClick={handlers.handleIconClick}
                onKeyDown={handlers.handleKeyDown}
                onTemplateDownload={handlers.handleTemplateDownload}
                onDevicesUpload={handlers.handleDevicesUpload}
                onSelectKeyDown={handlers.handleSelectKeyDown}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onClose={onClose}
            />
        </>
    );
};

const AddDeviceContainer = observer(Container);

export default AddDeviceContainer;
